import { render } from "./post-card-header.vue?vue&type=template&id=33f236ac"
import script from "./post-card-header.vue?vue&type=script&lang=js"
export * from "./post-card-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__